import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';

import * as styles from './timecode.css';

interface ITimecodeProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class Timecode extends React.Component<ITimecodeProps> {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: ITimecodeProps): boolean {
        return (
            nextProps.value.timecodeMode !== this.props.value.timecodeMode ||
            nextProps.value.duration !== this.props.value.duration ||
            nextProps.areControlsIdle !== this.props.areControlsIdle ||
            (
                nextProps.value.isShowRemainingMode &&
                nextProps.value.timeRemaining !== this.props.value.timeRemaining
            )
        );
    }

    public render(): JSX.Element {
        const testId = composeTokenList([
            TestIds.PLAYER_COUNTER_TIMECODE,
            [!this.props.areControlsIdle, TestIds.PLAYER_COUNTER_TIMECODE_VISIBLE]
        ]);

        return (
            <div
                className={styles.timecode}
                onClick={this.handleClick}
                data-test-id={renderTestId(testId)}
            >
                {this.props.value.humanReadableTimecode}
            </div>
        );
    }

    private handleClick(): void {
        this.props.uiEvents$.next({
            type: UiEventType.TIMECODE_TAP
        });
    }
}

export default Timecode;